module.exports = __webpack_public_path__ + "img/driver-lounge-no.ffa51475.svg";